var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode",style:({ width: _vm.Size, height: _vm.Size })},[_c('img',{attrs:{"src":_vm.qrcode,"alt":""}}),(_vm.maskText)?_c('div',{staticClass:"mask"},[_vm._v(_vm._s(_vm.maskText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }